import React from 'react'

//icons
import Icon from  '@/components/elements/icons/Icons'
import { IconLibrary } from  '@/interfaces/IconLibrary'

//helpers
import { contentUrlHref, getTypeLabel } from  '@/helpers/Content'



const MainMenuContentTile = ({item, listId, appGuid, isHome, status, archiveStatus}:{item, listId: any, appGuid: string, isHome:boolean, status: any, archiveStatus: JSX.Element | string}) => (
    <a className='main-menu-title-square' href={contentUrlHref(appGuid, item.id, listId)}>
        <span className='page-title'>
            {isHome && <Icon iconName={IconLibrary.HOME} sizeInPx='14' color='#343D4CBF'/>}
            
            <span className={isHome ? 'home-margin' : ''}>{item.title}</span>
        </span>
        
        <span className='page-type'>
            {status}
            <span className='type-text'>
                <span>{getTypeLabel(item.type)}</span>
                {!!archiveStatus && archiveStatus}
                {isHome && <><span className='bullet'>•</span><span>Home Screen</span></>}
            </span>
        </span>
    </a>
)

export default MainMenuContentTile